var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 54,
    viewBox: "0 0 41 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.139 47.179L9.86338 52.3656L0 51.7993L20.9785 0.465515L28.7619 0.598169L41 53.4655L30.3796 53.032L29.2913 48.211L12.139 47.179ZM23.5524 17.0893L15.2395 38.6019L28.0044 39.4333L23.5524 17.0893Z",
    fill: "#FFCC33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA);
export default __webpack_public_path__ + "static/media/a.e12c65e5da090ec053f126eeefe9088b.svg";
export { ForwardRef as ReactComponent };